export const routes = {
    user: {
        GET_SITE_SETTINGS: 'api/site-settings',
        WALLET_BALANCE: 'api/user-info',
        GET_USER_INFO : 'api/get-user-info',
        LOGIN_API:'api/user-login',
        DEMO_LOGIN_API:'api/demo-user',
        SEND_OTP: 'api/send-otp',
        REGISTER: 'api/registration',
        GET_FAVOURITE_LIST:'api/favorite-list',
        CHANGE_MY_PASSWORD: 'api/change-my-password',
        LOGOUT_API:'api/logout',
        LOGIN_WITH_OTP:'api/login-with-otp',
        SAVE_BETS: 'api/save-bet',
        MAKE_FAVOURITE: 'api/make-event-favorite',
        GET_FANCY_BOOK: 'api/get-fancy-book',
        GET_EVENT_EXPOSURES: 'api/get-event-book-and-fancy-exposures-by-event-id/:matchId',
        GET_OPEN_BETS: 'api/get-open-bets',
        OPEN_BETS_EVENT_LISTING: 'api/open-bets-event-listing',
        GET_STATEMENT_INFO: 'api/get-statements-info',
        GET_PROFIT_LOSS: 'api/get-user-pl-info',
        GET_PROFIT_LOSS_PL_DETAIL: 'api/get-user-pl-statements',
        GET_PROFIT_LOSS_MATCH_DETAIL: 'api/get-user-match-statements',
        GET_STATEMENTS: 'api/get-statements',
        CHANGE_STAKE_VALUES: 'api/change-stake-values',
        GET_MATKA_SINGLE_BETS: 'api/get-matka-single-bets/:id',
        SAVE_WORLI_MATKA_BET: 'api/save-worli-matka-bet',
        GET_THIRD_PARTY_API: 'api/load-third-party-url',
        // SEARCH API
        GET_SEARCH_EVENTS: 'api/searching-event/:searchKey',
        GET_ALL_MARKET_BOOK:'api/get-all-event-book-and-fancy-exposures-by-event-id',
        GET_MARKET_ANALYSIS:'api/get-market-analys-data',
        GET_SITE_VERSION: 'api/site-status-version',
        FORGOT_PASSWORD: 'api/reset-forgot-password',
        UPDATE_WALLET_TYPE: 'api/wallet-switch',


        // AUTH_REFRESH: 'api/auth-refresh',
        GET_WALLET_GETWAY: 'api/get-payment-getway-iframe-url',
        GET_PAYMENT_WALLET_GETWAY :'api/get-payment-getway-token',
        GET_MY_MARKETS: 'api/get-my-markets/:sport_type',
        // GET_MARKET_BETS: 'api/get-market-bets',
        ACTIVITY_LOG:'api/activity-logs',
        // GET_REFER_CODE : 'api/get-refer-code',
        // CHAT API
        GET_CHATBOT_IFRAME: 'api/chatbot/get-iframe-url',
        GET_CHATBOT_IFRAME_GUEST: 'api/chatbot/get-iframe-url-for-guest',
        FEEDBACK_API:'api/user-feedback',
        MARK_REDIRECT_NOTIFICATION :'api/redirect-to-notification',
        GET_ID_WALLET_WITHDRAW:'api/get-id/wallet-withdraw',
        GET_AUTO_UTR :'/api/wallet/get-auto-utr',
        // BONUS
        CLAIM_BONUS: 'api/claim-bonus',
        //AFFILIATE
        GET_AFFILIATE_DASHBOARD: 'api/get-affiliate-dashboard',
        GET_AFFILIATE_USERSLIST: 'api/get-affiliate-user-lists',
        GET_PROFIT_LOSS_EVENT_USERS: 'api/get-affiliate-profit-loss-events',
        AFFILIATE_REGISTER: 'api/add-user',
        GET_AFFILIATE_REGISTER_USER_COUNT: 'api/get-affiliate-registered-users-count',
        GET_PAYMENT_WALLET_GETWAY :'api/get-payment-getway-token',
        GET_ID_WALLET_WITHDRAW:'api/get-id/wallet-withdraw',
        UPDATE_USER_NAME: 'api/update-display-name',
        GET_USER_INFO : 'api/get-user-info',
        GET_STATEMENT_INFO: 'api/get-statements-info',

    },

   wallet: {
        //Config
        GET_WALLET_CONFIG :'client/config',
        UPDATE_TXN_PASSWORD: 'client/update-txn-password',
        
        // Deposit
        PARENT_PAYMENT_METHODS :'client/accounts-master-list',
        GET_AUTO_UTR :'/api/user/get-auto-utr',
        WALLET_DEPOSIT :'client/client-account-transaction',
        PAYMENT_GATEWAY :'client/payment-url',
        
        // Withdraw
        ACCOUNT_DETAILS :'client/client-account',
        DELETE_ACCOUNT :'client/delete-client-account/:accountId',
        ADD_ACCOUNT :'client/create-client-account',
        UPLOAD_AND_FETCH_QR_DATA: '/dir/settings/getSignedUrl',
        
        // History
        WALLET_HISTORY :'client/client-account-transaction',
        SENT_OTP_TO_MOBILE :'client/transaction-password/send-otp',
        RESET_WITHDRAWAL_PASSWORD :'client/transaction-password/verify-otp',
        CANCEL_REQUEST :'client/cancel-transaction-request/:transactionId',
        GET_PAYMENT_GATEWAY_URL : 'api/user/get-payment-gateway-url'
    },
    
    sports: {
        MATCHES_BY_SPORT_ID: 'v1/events/matches/:sport_id',
        GET_SPORTS: 'v1/sports/management/getSport',
        GET_MATCH_DETAILS: 'v1/events/matchDetails/:event_id',
        FIND_BY_IDS: 'v1/events/findByIds',
        INPLAY_MATCHES_COUNT: "v1/events/count",
        GET_MATKAS: '/v1/worli/public/matches',
        GET_MATKA_MARKETS: '/v1/worli/public/matches/:id/all/markets',
        GET_UPCOMING_SPORTS:'v1/events/sports/all',
        INPLAY_MATCHES_LIST :'v1/events/matches/inplay',
        // GET_MATKA_SINGLE_BETS: '/get-matka-single-bets/:id'
    },
    fantasy: {
        FANTASY_SETUP_DATA: '/get-setup-data',
        GET_REMEMBERED_MATCHES: '/get-remembered-matches',
        ADD_MATCH_REMINDER: '/add-match-reminder',
        REMOVE_MATCH_REMINDER: '/remove-match-reminder',
        PLAYERS_LIST_API: '/get-match-players-list/:matchId',
        GET_MY_STAKES: '/get-my-stakes',
        UPDATE_MY_STAKES: '/update-my-stakes',
        ADD_MY_TEAM: '/add-my-team',
        UPDATE_MYTEAM_NAME: '/update-my-teamname',
        BET_DETAILS: '/get-match-bet-details',
        PLACE_BET: '/place-bet',
        MY_CONTESTS_LIST: '/get-my-contests',
        MY_CONTEST_BET_LIST: '/get-match-teams-and-bet-details',
        CANCEL_BET: '/cancel-bet',
        GET_TEAM_DETAILS: '/get-team-details/:id',
        RESET_MYTEAM: '/reset-my-team',
        MATCHES_LIST_API :'/get-matches-list',
        TUTORIALS_API :'/get-tutorials',
    },
    bonus: {
        GET_BONUS_LOGS: 'api/v1/get-bonus-log',
        GET_BONUS_LOGS_DETAILS: 'api/v1/get-bonus-log-details',
        GET_USER_LOCKED_BONUS: 'api/v1/get-user-locked-bonus',
        GET_LOCKED_EARNED_BONUS: 'api/v1/get-locked-earn-bonus',
    },
    notification: {
        NOTIFICATIONS_LIST_API: 'api/get-notification',
        MARK_REDIRECT_NOTIFICATION: 'api/redirect-to-notification',
        UNREAD_NOTIFICATION_COUNT: 'api/get-unread-notifications-count',
        SUBSCRIBE_NOTIFICATION: 'api/subscribe-notification',
    }
};